export default __webpack_public_path__ + "locales/lo-LA/Translations.json?hash=08dce0121ca8989a3f04d8275d6b0a4d";